<template>
  <Layout theme="light">
    <HeaderComponents></HeaderComponents>
    <Content class="privacy-policy-page">
      <div class="privacy-policy-content" v-html="privacy_policy"></div>
    </Content>
    <FooterComponents></FooterComponents>
  </Layout>
</template>

<script>
import HeaderComponents from './components/header'
import FooterComponents from './components/footer'

export default {
  name: 'privacy-policy',
  components: {
    HeaderComponents,
    FooterComponents
  },
  data () {
    return {
      privacy_policy: ''
    }
  },
  created () {
    this.$request('635663a939a14').then(res => {
      this.privacy_policy = res.data.data.privacy_policy || ''
    })
  }
}
</script>

<style lang="less" scoped>
.privacy-policy-page {
  min-height: calc(100vh - 300px);
  margin-top: 64px;
  padding: 40px 100px;
  background: #fff;
}

.privacy-policy-content {
  max-width: 1200px;
  margin: 0 auto;
  line-height: 1.8;
  word-break: break-word;
}
</style>
